<template>
  <div class="banner-3" id="banner-3">
    <div class="container">
      <div class="row">
     
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/scss/global.scss';
  
  
</style>

<script>

export default {
  name: "banner-3",
};
</script>
